import { Route, State as RouteState } from 'config/routes';
import { call, fork, put, select } from 'redux-saga/effects';
import { queryData } from 'store/sagas/apiService';
import { LoadType } from 'store/sagas/apiService/types';
import { resetDomainData } from 'store/state/domainData/actions';
import { prevRouteSelector } from 'store/state/selectors/router';
import { managedOfficeSelector } from 'store/state/domainData/selectors';
import { navigateTo } from 'store/state/router/actions';


function* loadOfficeData() {
  const managedOfficeId: string | null = yield select(managedOfficeSelector);

  if (!managedOfficeId) {
    yield put(navigateTo(Route.AgentConsoleHomePage, {}, { replace: true }));
  }
  else {
    const prevRoute: RouteState | null = yield select(prevRouteSelector);

    if (prevRoute) {
      yield put(resetDomainData({ loadType: LoadType.GetPublicRealEstateOfficeById }));
      yield put(resetDomainData({ loadType: LoadType.TeamByOfficeId }));
    }

    yield fork(queryData, { loadType: LoadType.GetPublicRealEstateOfficeById, meta: { variables: { officeId: managedOfficeId } } });
    yield fork(queryData, { loadType: LoadType.TeamByOfficeId, meta: { variables: { id: managedOfficeId, shuffle: false } } });
  }
}

export function* officeStaffPageHandler() {
  yield call(loadOfficeData);
}
